var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Component from "../lib/component";
import html from "./header.html";
import "./header.scss";
import page from 'page';
var defaultOptions = {
    title: "",
    showBackButton: true
};
// class headerModel extends KnockoutModel{
// 	constructor(root:any){ super('',root,{})};
//         showMyPro=ko.observable(false);
//         zkMyPro(){
//             if(this.showMyPro()){
//                 this.showMyPro(false);
//             }else{
//                 this.showMyPro(true);
//             }
//         }
//     }
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    // hm:headerModel
    function MyComponent() {
        var _this = _super.call(this, "header", html) || this;
        _this.showMyPro = ko.observable(false);
        _this.goA = '0';
        _this.selectPage = ko.observable('');
        _this.back = function (e) {
            e.stopPropagation() || history.go(-1);
        };
        return _this;
    }
    MyComponent.prototype.ribao = function () {
        window.open('/file/daily', '_blank');
    };
    MyComponent.prototype.leaveHead = function (d, r) {
        this.showMyPro(false);
    };
    MyComponent.prototype.init = function () {
        ko.applyBindings(this, this.container.querySelector(".header-currency"));
        // this.showMyPro(false);
        // let MyPro=this.container.querySelector('#headMyPo');
        // MyPro.addEventListener('onclick',()=>{
        //     if(this.showMyPro()){
        //         this.showMyPro(false);
        //     }else{
        //         this.showMyPro(true);
        //     }
        // })
        // this.hm=new headerModel(this.container);
        // this.hm.bind();
        // ko.applyBindings({}, this.container)
        // let permission=window.localStorage.getItem("permission");
        // window.localStorage.setItem('indexPage', d.data.indexPage);
        // window.localStorage.setItem('infomationPool', d.data.infomationPool);
        // window.localStorage.setItem('projectNotice', d.data.projectNotice);
        // window.localStorage.setItem('fileSystem', d.data.fileSystem);
        // window.localStorage.setItem('userDaily', d.data.userDaily);
        // window.localStorage.setItem('systemSetting', d.data.systemSetting);
        // if (window.localStorage.getItem('indexPage') == '1') {
        //     let div = this.container.querySelector('#indexPage') as HTMLElement;
        //     div.style.display = 'block';
        // }
        // else {
        //     let div = this.container.querySelector('#indexPage') as HTMLElement;
        //     div.style.display = 'none';
        //     //console.log('权限——————————————————————————————————' + window.localStorage.getItem('indexPage'));
        // }
        var str = window.location.hash;
        var index = str.indexOf('?');
        if (index > -1) {
            str = str.substring(0, index);
        }
        else {
            str = str;
        }
        // console.log(str);
        // 
        // if (!Array.prototype.forEach) {
        //     Array.prototype.forEach = function (fun /*, thisp*/) {
        //         var len = this.length;
        //         if (typeof fun != "function")
        //             throw new TypeError();
        //         var thisp = arguments[1];
        //         for (var i = 0; i < len; i++) {
        //             if (i in this)
        //                 fun.call(thisp, this[i], i, this);
        //         }
        //     };
        // }
        var oDiv = this.container.querySelectorAll('.header-currency-frame');
        // console.log(oDiv)
        // debugger;
        // function addForEachToNodeList () {
        if (!NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
        // }
        oDiv.forEach(function (p) {
            if (p.querySelector('a').getAttribute('href') == str) {
                p.classList.add('active');
            }
            else if (p.querySelector('a').getAttribute('href') == '#/file/daily' && str == '#/file/dailyFlock') {
                p.classList.add('active');
            }
            else {
                p.classList.remove('active');
            }
        });
        if (window.localStorage.getItem('infomationPool') == '1') {
            var div = this.container.querySelector('#infomationPool');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#infomationPool');
            div.style.display = 'none';
            //console.log('权限——————————————————————————————————' + window.localStorage.getItem('infomationPool'));
        }
        if (window.localStorage.getItem('projectNotice') == '1') {
            var div = this.container.querySelector('#projectNotice');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#projectNotice');
            div.style.display = 'none';
            // console.log('权限——————————————————————————————————' + window.localStorage.getItem('projectNotice'));
        }
        if (window.localStorage.getItem('fileSystem') == '1') {
            var div = this.container.querySelector('#fileSystem');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#fileSystem');
            div.style.display = 'none';
            // console.log('权限——————————————————————————————————' + window.localStorage.getItem('fileSystem'));
        }
        if (window.localStorage.getItem('userDaily') == '1') {
            var div = this.container.querySelector('#userDaily');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#userDaily');
            div.style.display = 'none';
        }
        //console.log('权限——————————————————————————————————' + window.localStorage.getItem('userDaily'));
        if (window.localStorage.getItem('systemSetting') == '1') {
            var div = this.container.querySelector('#systemSetting');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#systemSetting');
            div.style.display = 'none';
        }
        // console.log('权限——————————————————————————————————' + window.localStorage.getItem('systemSetting'));
        //      console.log("init")
        //      this.options.showBackButton = this.options.showBackButton == undefined ? defaultOptions.showBackButton : this.options.showBackButton;
        //
        //      this.container.querySelector(".header__title")
        //          .innerHTML = this.options.title || ""
        //      let backButton = this.container.querySelector(".header__back-button")
        //      if (!this.options.showBackButton) {
        //          backButton.classList.add("hide")
        //      }
        //      if (this.options.onBack)
        //          backButton.addEventListener("click", () => this.options.onBack(), { capture: true });
        //      else
        //          backButton.addEventListener("click", () => history.go(-1), { capture: true });
        //      if (this.options.buttons) {
        //          let container = this.container.querySelector(".header__buttons-container");
        //          for (let but of this.options.buttons) {
        //              let b = document.createElement("a");
        //              b.innerHTML = but.text;
        //              if (but.cssClass) b.classList.add(but.cssClass)
        //              b.addEventListener("click", (e) => e.preventDefault() || but.e.apply(b));
        //              container.appendChild(b)
        //          }
        //      }
    };
    MyComponent.prototype.zkMyPro = function (d, r) {
        // console.log(d,'-------------');
        if (this.showMyPro()) {
            this.showMyPro(false);
        }
        else {
            if (this.goA == '0')
                this.showMyPro(true);
            var str = window.location.hash;
            var index = str.indexOf('?');
            if (index > -1) {
                str = str.substring(0, index);
            }
            else {
                str = str;
            }
            // console.log(str);
            // 市场情况及对手
            if (str == '#/project/marketAndOpponentAnalysis' || str == '#/project/addMarketAndOpponet' || str == '#/project/OpponentAnalysis' || str == '#/project/addOpponet') {
                this.selectPage('two');
            }
            // 拟收购
            if (str == '#/project/AcquiredBusiness' || str == '#/project/AddAcquiredBusiness') {
                this.selectPage('three');
            }
            // 项目列表
            if (str == '#/project/Myproject' || str == '#/project/edit' || str == '#/project/projectInfo') {
                this.selectPage('one');
            }
        }
    };
    MyComponent.prototype.goMyPro = function (d, r) {
        this.showMyPro(false); //
        // console.log(d,r);
        page(d);
        // this.goA='1'
    };
    MyComponent.prototype.update = function () {
        // this.showMyPro(false);
        // this.zkMyPro()
        // let nodeList= this.container.getElementsByTagName("a");
        //  this.container.querySelectorAll(".header-currency-frame");
        // for(let i=0;i<nodeList.length;i++){ 
        //     nodeList[i].addEventListener( "click",function(event){
        //         for(let i=0;i<nodeList.length;i++){ 
        //             nodeList[i].setAttribute("style","color:black");
        //         }
        //         event.srcElement.setAttribute("style","color:red");
        //     })
        // }
        // if (window.localStorage.getItem('indexPage') == '1') {
        //     let div = this.container.querySelector('#indexPage') as HTMLElement;
        //     div.style.display = 'block';
        // }
        // else {
        //     let div = this.container.querySelector('#indexPage') as HTMLElement;
        //     div.style.display = 'none';
        //    // console.log('权限——————————————————————————————————' + window.localStorage.getItem('indexPage'));
        // }
        var str = window.location.hash;
        var index = str.indexOf('?');
        if (index > -1) {
            str = str.substring(0, index);
        }
        else {
            str = str;
        }
        // console.log(str);
        var oDiv = this.container.querySelectorAll('.header-currency-frame');
        // console.log(str);
        if (!NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
        // debugger;
        oDiv.forEach(function (p) {
            // console.log(p.querySelector('a').getAttribute('href'))
            if (p.querySelector('a').getAttribute('href') == str) {
                p.classList.add('active');
            }
            else if (p.querySelector('a').getAttribute('href') == '#/file/daily' && str == '#/file/dailyFlock') {
                p.classList.add('active');
            }
            else {
                p.classList.remove('active');
            }
        });
        if (window.localStorage.getItem('infomationPool') == '1') {
            var div = this.container.querySelector('#infomationPool');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#infomationPool');
            div.style.display = 'none';
            // console.log('权限——————————————————————————————————' + window.localStorage.getItem('infomationPool'));
        }
        if (window.localStorage.getItem('projectNotice') == '1') {
            var div = this.container.querySelector('#projectNotice');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#projectNotice');
            div.style.display = 'none';
            //console.log('权限——————————————————————————————————' + window.localStorage.getItem('projectNotice'));
        }
        if (window.localStorage.getItem('fileSystem') == '1') {
            var div = this.container.querySelector('#fileSystem');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#fileSystem');
            div.style.display = 'none';
            // console.log('权限——————————————————————————————————' + window.localStorage.getItem('fileSystem'));
        }
        if (window.localStorage.getItem('userDaily') == '1') {
            var div = this.container.querySelector('#userDaily');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#userDaily');
            div.style.display = 'none';
        }
        // console.log('权限——————————————————————————————————' + window.localStorage.getItem('userDaily'));
        if (window.localStorage.getItem('systemSetting') == '1') {
            var div = this.container.querySelector('#systemSetting');
            div.style.display = 'block';
        }
        else {
            var div = this.container.querySelector('#systemSetting');
            div.style.display = 'none';
        }
        //  let nodeList= this.container.querySelector(".header-currency-frame") as HTMLElement;
        //   for(let i=0;i<nodeList.){
        //   }
        // if(window.localStorage.getItem('systemSetting')=='1') {
        //     let  div  =  document.getElementById('systemSetting') as HTMLElement; 
        //     div.style.display='block';
        //    }
        //    else{
        //     let  div  =  document.getElementById('systemSetting') as HTMLElement; 
        //     div.style.display='none';
        //     console.log('权限——————————————————————————————————'+window.localStorage.getItem('systemSetting'));
        // }
        // if(window.localStorage.getItem('projectNotice')=='1') {
        //         let  div  =  document.getElementById('projectNotice') as HTMLElement; 
        //         div.style.display='block';
        //        }
        //        else{
        //         let  div  =  document.getElementById('projectNotice') as HTMLElement; 
        //         div.style.display='none';
        //    }
        //    console.log('权限——————————————————————————————————'+window.localStorage.getItem('systemSetting'));
        // this.hm.loadData()
        return _super.prototype.update.call(this);
    };
    return MyComponent;
}(Component));
export { MyComponent };
export default new MyComponent();
